<template>
  <div>
    <div class="mb-4">
      <div class="w-full mb-4">
        <strong>{{ name }}</strong>
      </div>

      <div class="w-full"> 
        <vs-input 
        v-model="value"
        @blur="updateValue"
        class="mb-4 w-full" 
        :name="'text' + index"
        v-validate="isRequired ? 'required' : '' "
        :disabled="disabled"
        ></vs-input>

        <span class="text-danger text-sm" v-show="errors.has('text' + index)">
          Preenchimento do campo é obrigatório.
        </span>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    name: 'TextField',
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      items: {
        type: Array,
        required: false
      },
      description: {
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        value: null,
        isRequired: false
      }
    },
    computed:  {
      name(){
        if ( !this.description || this.description.description == ''){
          return;
        } 
        else if ( this.description.description ){
          return this.description.description;
        }
        return this.description;
      }
    },
    methods: {
      updateValue () {
        this.items.forEach((item, idx) => {
          this.$emit('valueChanged', this.index, idx, this.value)
        })
      }
    },
    created() {
      if (!this.items) { return;}
      this.items.forEach((item) => {
        this.isRequired = item.reason_option_is_required

        if( !item.value ){ return; }
        this.value = item.value
      })
    }
  }
</script>
